import { isCurrencyCodeString } from 'pricing-pages-ui-components/currency/types';
export function buildHsocPriceDisplay(pricing, selectedTerm, currencyCode, tierName) {
  if (!isCurrencyCodeString(currencyCode)) {
    return undefined;
  }

  /* The FREE tier has no purchase options; mirror the public pages and show an
   * explicit $0 rather than no price. */
  if (tierName === 'FREE') {
    return {
      price: 0,
      currencyCode
    };
  }
  if (!pricing) {
    return undefined;
  }
  const option = pricing.purchaseOptions[selectedTerm];
  if (!option) {
    return undefined;
  }
  const price = Number(option.monthlyPrice);
  if (option.monthlyPrice.trim() === '' || !Number.isFinite(price)) {
    return undefined;
  }
  const resolvedCurrencyCode = currencyCode;
  return {
    price,
    currencyCode: resolvedCurrencyCode
  };
}
export function hasMultipleBillingTerms(productsByTier) {
  if (!productsByTier) {
    return false;
  }
  return Object.values(productsByTier).some(tier => Object.keys(tier.pricing.purchaseOptions).length > 1);
}